/**
 * api/qrWorklist.ts
 * ─────────────────
 * Client for the customer-facing QR Correction Worklist endpoints.
 * Accessible to all authenticated users (incl. customer role).
 */

import { apiClient } from './client';

export type QrFaultCategory =
  | 'wrong_qr_at_slot'    // v1.2 — QR for B found at assigned slot A (HIGHLIGHTED)
  | 'missing_qr'
  | 'misplaced_swapped_qr'
  | 'damaged_qr';

export interface QrWorklistEntry {
  location_code: string;
  fault_type: string;
  category: QrFaultCategory;
  category_label: string;
  confidence: number;
  confidence_label: 'low' | 'medium' | 'high';
  evidence: string;
  recommended_fix: string;
  swapped_with: string | null;
  photo_ids: string[];
}

export interface QrWorklist {
  mission_id: string;
  warehouse_id: string;
  total_flagged: number;
  /** v1.2 — QR rework rule: QR for B physically found at assigned slot A. HIGHLIGHTED. */
  wrong_qr_at_slot: QrWorklistEntry[];
  missing_qr: QrWorklistEntry[];
  misplaced_swapped_qr: QrWorklistEntry[];
  damaged_qr: QrWorklistEntry[];
}

export async function fetchQrWorklist(missionId: string): Promise<QrWorklist> {
  return apiClient.get<QrWorklist>(`/api/qr-worklist/missions/${missionId}`);
}

export function qrWorklistExportUrl(missionId: string): string {
  return `/api/qr-worklist/missions/${missionId}/export.xlsx`;
}
